import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function ProductOverview() {
  const tomos = [{
    emoji: '🟠',
    title: 'TOMO 1',
    level: 'El ADN de la Masa',
    content: 'La base de todo. Acá no hay secretos. Masa base paso a paso explicada para principiantes absolutas.',
    image: 'https://cdn.magicpatterns.com/uploads/tRdQUjYACniv3c4y7qh9yQ/hf_20260421_223212_0d3b5dec-cbf2-4304-b819-5b91462370a3.png'
  }, {
    emoji: '🟡',
    title: 'TOMO 2',
    level: 'Master de Glaseados, Colores y Toppings',
    content: 'Las minidonas que la gente no puede dejar de fotografiar. Glaseados paso a paso: básico, chocolate, ganache, espejo.',
    image: 'https://cdn.magicpatterns.com/uploads/qtQLCYSZjgY3ECAvsJ41u3/hf_20260421_224110_34d18f3d-abdb-4963-83ad-3e0261fcd4b3.png'
  }, {
    emoji: '🟢',
    title: 'TOMO 3',
    level: 'Minidonas Saladas: El Sabor Argento',
    content: 'La clave para diferenciarte de la competencia. Ideales para eventos y picadas donde todos llevan lo mismo. ¡Sé la primera en ofrecerlas!',
    image: 'https://cdn.magicpatterns.com/uploads/ukkTZTA8FXkcKvi5mGx8BY/tomo_3_donas.png',
    highlight: true,
    badge: '⭐ EL DIFERENCIAL'
  }, {
    emoji: '🔵',
    title: 'TOMO 4',
    level: 'Minidonas Fritas',
    content: 'Las que más se venden en ferias y eventos. La versión irresistible. Masa levada paso a paso con sus tiempos exactos.',
    image: 'https://cdn.magicpatterns.com/uploads/2krH6go81kULM1NzdNodAz/TOMO_4.png'
  }, {
    emoji: '🟣',
    title: 'TOMO 5',
    level: 'Packaging y Presentación',
    content: 'Porque la primera venta entra por los ojos. Tipos de cajas y materiales de packaging disponibles en Argentina.',
    image: 'https://cdn.magicpatterns.com/uploads/7CptmvbJAhaMxUYiWfmbro/TOMO_5.png'
  }, {
    emoji: '🔴',
    title: 'TOMO 6',
    level: 'Tu Negocio en Pesos',
    content: 'No pierdas plata. Te enseñamos a calcular el costo real en pesos argentinos hoy y cómo usar WhatsApp para que los pedidos lleguen solos.',
    image: 'https://cdn.magicpatterns.com/uploads/8sTv2nR2yzUbeAwmdGgFa2/TOMO_6.png'
  }];
  const includes = ['Recetas y técnicas listas para aplicar', 'Explicaciones paso a paso aptas para principiantes', 'Tablas, checklists y registros descargables', 'Adaptado al contexto argentino (ingredientes, precios, proveedores)', 'Lenguaje claro y directo — sin términos de pastelería profesional'];
  return <section className="w-full bg-[#FBF5EC] py-4 md:py-8" data-id="element-206">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-207">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-208">
          <div className="text-center mb-3 md:mb-6" data-id="element-209">
            <h2 className="text-3xl md:text-5xl font-bold text-[#3D2817] mb-1 md:mb-2" data-id="element-210">
              🏆 MEGA PACK EMPRENDE MINIDONAS 360
            </h2>
            <p className="text-xl md:text-2xl text-[#B45309] font-semibold mb-1" data-id="element-211">
              6 Tomos + 4 Bonos — Masa → Negocio en Pesos
            </p>
            <p className="text-2xl md:text-3xl font-bold text-[#3D2817]" data-id="element-212">
              Todo resuelto. Paso a paso. Desde cero.
            </p>
          </div>

          <div className="mb-4 md:mb-6" data-id="element-213">
            <h3 className="text-2xl md:text-3xl font-bold text-[#3D2817] mb-3 md:mb-4 text-center" data-id="element-214">
              📚 LOS 6 TOMOS COMPLETOS
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4" data-id="element-215">
              {tomos.map((tomo, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1,
              duration: 0.5
            }} className={`rounded-lg p-4 relative overflow-hidden transition-shadow ${tomo.highlight ? 'bg-gradient-to-b from-[#FDF1E4] to-white border-2 border-[#B45309] shadow-lg ring-1 ring-[#B45309]/20 hover:shadow-xl' : 'bg-white border border-[#E8D5BA] shadow-sm hover:shadow-md'}`} data-id="element-216">
                  {tomo.highlight && tomo.badge && <div className="inline-block bg-[#B45309] text-white text-[10px] font-bold tracking-wide px-2.5 py-1 rounded-full mb-2" data-id="element-217">
                      {tomo.badge}
                    </div>}
                  {tomo.image && <div className="absolute top-2 right-2 w-12 h-16" style={{
                perspective: '500px'
              }} data-id="element-218">
                      <div className="relative w-full h-full rounded-sm shadow-[3px_3px_8px_rgba(61,40,23,0.25)]" style={{
                  transform: 'rotateY(-12deg)',
                  transformStyle: 'preserve-3d'
                }} data-id="element-219">
                        <img src={tomo.image} alt="" className="w-full h-full object-cover rounded-sm" data-id="element-220" />
                        <div className="absolute top-0 left-0 w-[3px] h-full bg-gradient-to-r from-[#B8855C] to-[#D4A373] rounded-l-sm" data-id="element-221" />
                        <div className="absolute inset-0 rounded-sm bg-gradient-to-r from-black/10 via-transparent to-transparent pointer-events-none" data-id="element-222" />
                      </div>
                    </div>}
                  <div className="text-3xl mb-2" data-id="element-223">{tomo.emoji}</div>
                  <h4 className={`text-base font-bold text-[#3D2817] mb-1 ${tomo.image ? 'pr-14' : ''}`} data-id="element-224">
                    {tomo.title}
                  </h4>
                  <p className="text-[#B45309] font-semibold mb-2 text-sm" data-id="element-225">
                    {tomo.level}
                  </p>
                  <p className="text-[#6B5747] text-sm leading-relaxed" data-id="element-226">
                    {tomo.content}
                  </p>
                </motion.div>)}
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white border border-[#E8D5BA] rounded-lg p-4 md:p-6 shadow-sm" data-id="element-227">
            <h3 className="text-lg md:text-xl font-bold text-[#3D2817] mb-2 md:mb-3 text-center" data-id="element-228">
              Cada tomo incluye:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-229">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-2" data-id="element-230">
                  <CheckCircleIcon className="w-4 h-4 text-[#B45309] flex-shrink-0 mt-0.5" data-id="element-231" />
                  <p className="text-[#6B5747] text-sm" data-id="element-232">{item}</p>
                </div>)}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}